import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import MobileMessage from '@/components/MobileMessage/MobileMessage';
import LoginViewContent from '@/components/LoginViewContent/LoginViewContent';
import UseScreenSize from '@/hooks/UseScreenSize';
import { authActions } from '@/store/reducers/auth';
import userThunks from '@/store/thunks/user';
import { useAppDispatch } from '@/store';

type Props = {};

const MobileBlocker = ({}: Props) => {
  const { t } = useTranslation();
  const { isMobile } = UseScreenSize();
  const dispatch = useAppDispatch();

  const onClose = useCallback(
    (source: string) => {
      if (source !== 'button') {
        return;
      }

      dispatch(userThunks.signOut());
      dispatch(authActions.signOut());
    },
    [dispatch]
  );

  return (
    <MobileMessage show={isMobile} message={t('admin.desktopOnlyMessage')} onClose={onClose}>
      <LoginViewContent />
    </MobileMessage>
  );
};

export default MobileBlocker;
